export * from './patient-stopdeal.component';
export * from './patient-stopdeal.service';